import Index from '@/components/twicehands/Index'
import Detail from '@/components/twicehands/Detail'
import CollectIndex from '@/components/twicehands/CollectIndex'
import Mysends from '@/components/twicehands/Mysends'
import MysendBuy from '@/components/twicehands/MysendBuy'
export default [
    {
        path: '/',
        name: 'twicehands-index',
        component: Index,
		meta: { title: '二手交易' }
    },
    {
        path: '/twicehands/detail',
        name: 'twicehands-detail',
        component: Detail,
		meta: { title: '二手交易' }
    },
	{
		path: '/twicehands/collect',
		name: 'twicehands-collect',
		component: CollectIndex,
		meta: { title: '我的收藏' }
	},
	{
		path: '/twicehands/mysends',
		name: 'twicehands-mysends',
		component: Mysends,
		meta: { title: '我的发布' }
	},
	{
		path: '/twicehands/MysendBuy',
		name: 'twicehands-MysendBuy',
		component: MysendBuy,
		meta: { title: '我的求购' }
	}

]


// WEBPACK FOOTER //
// ./src/router/TwicehandsRouter.js